import React from 'react'
import { ReactComponent as AnnounceRound } from '../../images/icons/sales.svg'

type Props = {
  reason: string
  title: string
  onClick: (event: React.MouseEvent<HTMLElement>) => void
}

const AudienceSuggestionAction = ({ reason, title, onClick }: Props): JSX.Element => {
  return (
    <div
      className={
        'flex flex-row bg-primary-persian-blue/10 rounded-lg border-2 border-dashed border-silver'
      }>
      <div
        className={
          'ml-2 my-2 flex justify-center items- my-auto rounded-full bg-white h-10 w-10'
        }>
        <AnnounceRound
          className={
            'bg-white rounded-full my-auto stroke-primary-persian-blue h-[25px] w-[25px]'
          }
        />
      </div>
      <div
        className={'flex flex-col ml-2 mb-2 p-2 justify-start items-center ml-2 mr-auto'}>
        <span className={'font-Spartan mt-2 mr-auto text-[10px] text-primary-glaucous'}>
          {reason}
        </span>
        <span className={'font-Spartan font-medium mt-2 mr-auto text-sm'}>{title}</span>
      </div>

      <div
        className="mr-2 ml-auto !w-[150px] my-auto cursor-pointer w-[80px]"
        onClick={onClick}>
        <span className="font-bold text-sm">Continue with this</span>
      </div>
    </div>
  )
}

export default AudienceSuggestionAction
